/**
 * © 2026 Indikin.online. All rights reserved.
 * Made with ❤️ by YalaCoder.
 *
 * Content Service
 * Handles fetching individual content items (films/series) efficiently.
 */

import { getDb, loadFirestoreSDK } from './firestore';

/**
 * Retrieves a single film's metadata by ID.
 * Used for the Resume Prompt to avoid loading the entire dashboard library.
 * 
 * @param {string} filmId 
 * @returns {Promise<Object|null>} Film data or null if not found
 */
export const getFilmById = async (filmId) => {
    if (!filmId) return null;

    try {
        const db = await getDb();
        const { doc, getDoc } = await loadFirestoreSDK();

        const docRef = doc(db, 'films', filmId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            return { id: docSnap.id, ...docSnap.data() };
        }
        return null;
    } catch (error) {
        console.warn(`[ContentService] Failed to fetch film ${filmId}:`, error);
        return null;
    }
};
